var _g, _g2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMaskedPasswordCount({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 39,
    viewBox: "0 0 52 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8432_140504)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 12.5141,
    y1: -2.29026,
    x2: -6.18612,
    y2: 16.41,
    stroke: "white",
    strokeWidth: 2.33753
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.631,
    y1: 0.82644,
    x2: -3.0692,
    y2: 19.5266,
    stroke: "white",
    strokeWidth: 2.33753
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.0848,
    y1: 1.60574,
    x2: -0.732126,
    y2: 23.4227,
    stroke: "white",
    strokeWidth: 2.33753
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.7606,
    y1: 3.16384,
    x2: -2.28973,
    y2: 31.2142,
    stroke: "white",
    strokeWidth: 2.33753
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.7606,
    y1: 9.39724,
    x2: -2.28973,
    y2: 37.4476,
    stroke: "white",
    strokeWidth: 2.33753
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.7606,
    y1: 15.6311,
    x2: -2.28973,
    y2: 43.6814,
    stroke: "white",
    strokeWidth: 2.33753
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.7606,
    y1: 21.864,
    x2: -2.28973,
    y2: 49.9144,
    stroke: "white",
    strokeWidth: 2.33753
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.7606,
    y1: 28.0979,
    x2: -2.28973,
    y2: 56.1482,
    stroke: "white",
    strokeWidth: 2.33753
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8432_140504)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 41.1344,
    y1: -2.29026,
    x2: 22.4342,
    y2: 16.41,
    stroke: "white",
    strokeWidth: 2.33753
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.2512,
    y1: 0.82644,
    x2: 25.551,
    y2: 19.5266,
    stroke: "white",
    strokeWidth: 2.33753
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.7051,
    y1: 1.60574,
    x2: 27.8882,
    y2: 23.4227,
    stroke: "white",
    strokeWidth: 2.33753
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.3814,
    y1: 3.16384,
    x2: 26.3311,
    y2: 31.2142,
    stroke: "white",
    strokeWidth: 2.33753
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.3814,
    y1: 9.39724,
    x2: 26.3311,
    y2: 37.4476,
    stroke: "white",
    strokeWidth: 2.33753
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.3814,
    y1: 15.6311,
    x2: 26.3311,
    y2: 43.6814,
    stroke: "white",
    strokeWidth: 2.33753
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.3814,
    y1: 21.864,
    x2: 26.3311,
    y2: 49.9144,
    stroke: "white",
    strokeWidth: 2.33753
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.3814,
    y1: 28.0979,
    x2: 26.3311,
    y2: 56.1482,
    stroke: "white",
    strokeWidth: 2.33753
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8432_140504"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.3753,
    height: 38.9588,
    rx: 11.6876,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8432_140504"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.6208,
    width: 23.3753,
    height: 38.9588,
    rx: 11.6876,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaskedPasswordCount);
export default __webpack_public_path__ + "static/media/masked-password-count.3059f5827df3b1a06577fff6063888a4.svg";
export { ForwardRef as ReactComponent };